var BraintreeModule = (function (BraintreeClient, BraintreeHostedFields, BraintreePayPal, BraintreeKount, BraintreeVisaCheckout, braintree, $) {

    var _clientReady = new $.Deferred();

    var Braintree = function (opts) {
		this.fieldErrorClass = '';
		this.stylesOptions = {};
		this.fieldsOptions = {};
		this.btEnvironment = '';
		this.kountEnabled = '';
		this.kountMerchantID = '';
		this.usePayPal = false;
		this.useHostedfields = true;
		this.currency = '';
        this.currencyIso = '';
		this._$setup = new $.Deferred();
        this._$setupPromise = this._$setup.promise();
        this._initClient();
		$.extend(this, opts);
     };

    $.extend(Braintree.prototype, {
        init: function (opts) {
    		this.btEnvironment = opts.btEnvironment || this.btEnvironment;
    		this.kountMerchantID = opts.kountMerchantID || this.kountMerchantID;
    		this.kountEnabled = opts.kountEnabled || this.kountEnabled;
    		this.currency = opts.currency || this.currency;
            this.currencyIso = opts.currencyIso || this.currencyIso;

    		if (opts.useHostedfields !== undefined && opts.useHostedfields !== null) {
    			this.useHostedfields = opts.useHostedfields;
		    }

    		if (opts.usePayPal !== undefined && opts.usePayPal !== null) {
    			this.usePayPal = opts.usePayPal;
		    }

            if (this.useHostedfields) {
                this.hostedFields = new BraintreeHostedFields({
                    stylesOptions: this.stylesOptions,
                    fieldsOptions: this.fieldsOptions,
                    fieldErrorClass: this.fieldErrorClass
                });
            }
            this.paypal = new BraintreePayPal({ currency: this.currency, env: opts.payPalEnvironment });
            this.threeDS = new BraintreeThreeDS();
            this.kount = new BraintreeKount({btEnvironment: this.btEnvironment, kountEnabled: this.kountEnabled, kountMerchantID: this.kountMerchantID});
            this.visaCheckout = new BraintreeVisaCheckout({ currency: this.currencyIso });
            
            return _clientReady
                .then($.proxy(this._initKount, this))
                .then($.proxy(this._initPayPal, this))
                .then($.proxy(this._initHostedFields, this))
                .then($.proxy(this._initthreeDS, this))
                .then($.proxy(this._initVisaCheckout, this))
        		.then(this._$setup.resolve);
        },
        _initClient: function () {


            app.settings.ready(function() {
                var IsAuth = window.IsAuthorized || null;
                var _isPublic = false;
                if (IsAuth) {
                    _isPublic = !IsAuth();
                }
                BraintreeClient.init(_isPublic).done(function(clientInstance) {
                    _clientReady.resolve(clientInstance);
                });
            });


        },
    	_initHostedFields: function (clientInstance) {
	        if (this.hostedFields) {
	            return this.hostedFields.init(clientInstance);
	        }
	        return this._skipStep(clientInstance);
	    },
    	_initPayPal: function (clientInstance) {
        	if (!this.usePayPal) return this._skipStep(clientInstance);
            return this.paypal.init(clientInstance);
        },
    	_initthreeDS: function (clientInstance) {
            return this.threeDS.init(clientInstance);
        },
    	_initKount: function (clientInstance) {
            return this.kount.init(clientInstance);
        },
        _initVisaCheckout: function (clientInstance) {
            return this.visaCheckout.init(clientInstance);
        },
        _skipStep: function (clientInstance) {
			return new $.Deferred().resolve(clientInstance).promise();
		},
    	onSetupDone: function(callback) {
    		this._$setupPromise.done(callback);
	    }
    });
    
    return Braintree;
})(window.BraintreeClient, window.BraintreeHostedFields, window.BraintreePayPal, window.BraintreeKount, window.BraintreeVisaCheckout, window.braintree, jQuery);